import {
    TestDefinition,
    TestDefinitionFormValues,
    TestDefinitionStatus,
} from '../types';

// Turns a stored TestDefinition (which may have steps: NULL, and steps whose
// `inputs` are NULL) into form values the editors can always write into.
//
// Steps are ordered by `stepNumber` here, because the ARRAY ORDER is what the
// editor treats as the source of truth. If the API ever returned them out of
// order, rendering the raw array would show an order that disagrees with the
// stored stepNumbers — and then a save would renumber to whatever was displayed,
// silently rewriting the authored sequence.
//
// `__typename` is dropped from the nested objects — sending it back inside
// TestStepInput / StepInputInput would be rejected as an unknown field. (Same
// trap as WeightedActionCodeInput in testing-personas.)
export const buildInitialValues = (record?: TestDefinition): TestDefinitionFormValues => {
    return {
        id: record?.id ?? '',
        testCode: record?.testCode ?? '',
        name: record?.name ?? '',
        description: record?.description ?? '',
        // '' rather than undefined so the Select is a controlled field from the
        // first render. Normalised back to null on save (see the service) —
        // `applicationId: ID` is nullable and '' is not a valid id.
        applicationId: record?.applicationId ?? '',
        // status is NonNull on create with no server default. It is left blank
        // for a NEW record on purpose so the author must choose it explicitly
        // (the schema requires it); an existing record keeps whatever it has.
        status: record?.status ?? ('' as TestDefinitionStatus),
        steps: [...(record?.steps ?? [])]
            .sort((a, b) => (a.stepNumber ?? 0) - (b.stepNumber ?? 0))
            .map(step => ({
                stepNumber: step.stepNumber,
                actionCode: step.actionCode,
                expect: step.expect,
                inputs: (step.inputs ?? []).map(input => ({
                    key: input.key,
                    value: input.value,
                })),
            })),
    };
};
